import React, { Component } from "react";
import { useHistory } from "react-router-dom";
import app from "./firebase";
import firebase from "firebase/app";
import "firebase/database";
import { BsFillSquareFill } from "react-icons/bs";
import { FaProcedures } from "react-icons/fa";
import { Container, Row, Col, Button } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import { useAuth } from '../contexts/AuthContext';
import FadeLoader from "react-spinners/FadeLoader";

export const ButtonContext = React.createContext()

class ChamberClass extends Component {
// state = {
  //   chambers: [],
  //   mq2Value2: 0,
  //   mq9Value2: 0,
  //   mq135Value2: 0,
  //   tempValue2: 0, 
  //   humidValue2: 0,
  //   bodyTempValue2: 0,
  //   bodyOxValue2: 0,
  //   bodyDysValue2: 0,
  //   bodySysValue2: 0,
  //   bodyHeartRateValue2: 0,
  //   colorButton: "",
  // };
  state = {
    rooms: [],
    loading:true
  };

const 

  constructor(props) {
    super(props);
    // this.routeChange = this.routeChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }


  handleClick(event){
    const id = event.currentTarget.id
    
    console.log(id)
    let path = `${window.location.pathname}/${id.toLowerCase()}`;
    console.log("Path: ",path)
    this.props.history.push(path);
}
  // routeChange() {
  //   this.handleClick()
  //   let path = `/patient`;
  //   this.props.history.push(path);
  // }

  // mq2Condition = () => {
  //   return (this.state.mq2Value2_Chamber1 >= 50 && this.state.mq2Value2_Chamber1 <= 200 
  //     || this.state.mq2Value2_Chamber11 >= 50 && this.state.mq2Value2_Chamber11
  //     || this.state.mq2Value2_Chamber12 >= 50 && this.state.mq2Value2_Chamber12
  //     || this.state.mq2Value2_Chamber13 >= 50 && this.state.mq2Value2_Chamber13
  //     || this.state.mq2Value2_Chamber14 >= 50 && this.state.mq2Value2_Chamber14
  //     || this.state.mq2Value2_Chamber15 >= 50 && this.state.mq2Value2_Chamber15
  //     || this.state.mq2Value2_Chamber16 >= 50 && this.state.mq2Value2_Chamber16
  //     || this.state.mq2Value2_Chamber17>= 50 && this.state.mq2Value2_Chamber17
  //     || this.state.mq2Value2_Chamber18 >= 50 && this.state.mq2Value2_Chamber18
  //     || this.state.mq2Value2_Chamber19 >= 50 && this.state.mq2Value2_Chamber19
  //     || this.state.mq2Value2_Chamber20 >= 50 && this.state.mq2Value2_Chamber20
  //     || this.state.mq2Value2_Chamber21 >= 50 && this.state.mq2Value2_Chamber21
  //     || this.state.mq2Value2_Chamber22 >= 50 && this.state.mq2Value2_Chamber22
  //     || this.state.mq2Value2_Chamber23 >= 50 && this.state.mq2Value2_Chamber23  )
    

  // }

  getColorForButtons = (room) => {
    console.log("getColor: ",room.roomData.sensorData)
    const humidity=room.roomData.sensorData.room.humid[Object.keys(room.roomData.sensorData.room.humid)[Object.keys(room.roomData.sensorData.room.humid).length - 1]]?.value  || room.roomData.sensorData.room.humid; 
    const mq2 = room.roomData.sensorData.room.mq2[Object.keys(room.roomData.sensorData.room.mq2)[Object.keys(room.roomData.sensorData.room.mq2).length - 1]]?.value || room.roomData.sensorData.room.mq2;
    const mq9 = room.roomData.sensorData.room.mq9[Object.keys(room.roomData.sensorData.room.mq9)[Object.keys(room.roomData.sensorData.room.mq9).length - 1]]?.value || room.roomData.sensorData.room.mq9;
    const mq135 = room.roomData.sensorData.room.mq135[Object.keys(room.roomData.sensorData.room.mq135)[Object.keys(room.roomData.sensorData.room.mq135).length - 1]]?.value || room.roomData.sensorData.room.mq135;
    const temp = room.roomData.sensorData.room.temp[Object.keys(room.roomData.sensorData.room.temp)[Object.keys(room.roomData.sensorData.room.temp).length - 1]]?.value || room.roomData.sensorData.room.temp;
    const bloodOxygen = room.roomData.sensorData.body ? room.roomData.sensorData.body.blood_oxygen : 96;
    const bloodPressureDiastolic = room.roomData.sensorData.body ? room.roomData.sensorData.body.blood_pressure_diastolic : 70;
    const bloodPressureSystolic = room.roomData.sensorData.body ? room.roomData.sensorData.body.blood_pressure_systolic : 100;
    const bodyTemperature = room.roomData.sensorData.body ? room.roomData.sensorData.body.body_temperature : 36.5;
    const heartRate = room.roomData.sensorData.body ? room.roomData.sensorData.body.heart_rate : 70;  //Need to get accurate range for this 
    console.log(humidity, mq2, mq9, mq135, temp,bloodOxygen, bloodPressureDiastolic, bloodPressureSystolic, bodyTemperature, heartRate)
    if ((humidity <= 30 || humidity>= 70 ) || (mq2 >10000) || (mq9>2000) || (mq135>1200) || (temp>45) || (bloodOxygen<90) || (bloodPressureDiastolic>90) || (bloodPressureSystolic>140) || (bodyTemperature>38.5) || (heartRate<60 || heartRate>120))
      return "red";   
    else if (((humidity>= 30 && humidity<=50)||(humidity>=60 && humidity <=70)) || (mq2>50 && mq2<=10000) || (mq9>300 && mq9<=2000) || (mq135>100 && mq135<=1200) || (temp>25 && temp<=45) || (bloodOxygen>=90 && bloodOxygen<=95) || (bloodPressureDiastolic>=80 && bloodPressureDiastolic<=90) || (bloodPressureSystolic>130 && bloodPressureSystolic<=140) || (bodyTemperature>37.5 && bodyTemperature <=38.5) || (heartRate>=100 && heartRate <=120))
      return "yellow";
    else if ((humidity >= 50 && humidity<= 60) && (mq2 <=50) && (mq9>=20 && mq9<=300) && (mq135<=100) && (temp<=25) && (bloodOxygen>=95) && (bloodPressureDiastolic<=80) && (bloodPressureSystolic<=130) && (bodyTemperature>=36.5 && bodyTemperature<=37.5) && (heartRate>=60 && heartRate<=100))
      return "green"; 
    else return "blue"; //indicating error while reading sensor values (negative values or 0)
  }

  getButtonsUsingMap = () => {
    console.log("state", this.state);
    return this.state.rooms.map((room) => {
      return (
        <Col lg={2} md={3} xs={4} className="pl-3 pr-3 pt-2">
          <button id={room.roomKey} onClick={this.handleClick} className="btn" >
            <i className="fas fa-procedures fa-5x" 
              style={{ color:this.getColorForButtons(room) }}
              key={room.roomKey}>
            </i>
            <center>
              <strong>
                <p className="mb-1">{room.roomKey}</p>
              </strong>
            </center>
            <center>
              <p>Patient {room.roomKey.split("-")[1]}</p>
            </center>
          </button>
        </Col>
      );
    });
  };



//   colorChange=()=>{
//     this.ListenValue()
//     var colorButton
//     if (this.mq2Value2 >= 50 && this.mq2Value2 <= 200){
//       colorButton = "green"
//       this.setState({colorButton})
//       return console.log("hello")
//     }
//     if (this.mq2Value2 >= 200 && this.mq2Value2 <= 10000){
//       colorButton = "yellow"
//       this.setState({colorButton})
//     }
//     else {
//       this.setState({colorButton})
//     }
//   }



  componentDidMount() {
    console.log(1)
    var roomsListen = firebase.database().ref(`/Hospitals/${this.props.match.params.id[0].toUpperCase()+this.props.match.params.id.slice(1, this.props.match.params.id.length).toLowerCase()}/Rooms`);
    roomsListen.on("value", (snapshot) => {
      const rooms = [];
      snapshot.forEach((room) => {
        const roomKey = room.key;
        const roomData = room.val();
        rooms.push({roomKey, roomData});
        rooms.sort();
        // document.getElementById("Chambers").innerHTML = chambers
      });
      console.log("Rooms: ",rooms);

      this.setState({ rooms });
      this.setState({loading:false});
    });

  //   orderByKey().limitToLast(1).once('child_added').then((datashot) =>{
  //     const number = datashot.child('cnumber').val();
  //     agent.add('The number is' + number);  
  //     return number;
  // });
    

 
    
  }

  render() {
    return (
      <Container>
        <br></br>
      <div className="px-md-5">
        <h4 className="RoomsTitle">Rooms</h4>
        
        <hr></hr>
        {this.state.loading? <FadeLoader color={"#008db9"} loading={true} size={40} />:<Row>{this.getButtonsUsingMap()}</Row>}
      </div>
    </Container>
    );
  }
  
}

export default withRouter(ChamberClass)